import { render, staticRenderFns } from "./BlockchainPickerForm.vue?vue&type=template&id=88c74ebe&scoped=true&"
import script from "./BlockchainPickerForm.vue?vue&type=script&lang=js&"
export * from "./BlockchainPickerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c74ebe",
  null
  
)

export default component.exports